const dialogTransPath = 'home.components.dialog.';
const homeComponentButtonMsgPath = 'button.';

const translations = {
    DIALOG_TITLE : dialogTransPath + 'title',

    SSO_ENABLED_MSG : dialogTransPath + 'externalNavigationMessageSSOEnabled',
    NON_SSO_ENABLED_MSG : dialogTransPath + 'externalNavigationMsgNonSSOEnabled',
    CHECK_BOX_MSG : dialogTransPath + 'checkBoxMsg',

    CANCEL_AND_STAY_BTN : homeComponentButtonMsgPath + 'cancelAndStay',
    CONTINUE_TO_EXTERNAL_SITE_BTN : homeComponentButtonMsgPath + 'continueToExtSite'
}

export default translations